<!-- <mis-dropdown [data]="selectOptions" [selectedItem]="selectedItem" ngDefaultControl name="displayValue" [(ngModel)]="displayValue" [searchEnabled]="false" (onChange)="onOptionClick($event)" [ngClass]="(((config?.displayName === 'Gender' || config?.displayName === 'City' || config?.displayName === 'Booking Type' || config?.displayName === 'Cab Type' || config?.displayName === 'Vendor') && (styleApplied !== 'editable-table' || selectStyleApplied === 'editable-table')) || (config?.displayName === 'Department' && selectStyleApplied !== 'editable-table') || (config?.displayName === 'Code' && selectStyleApplied !== 'editable-table')) ? 'mis-dropdown-56' : 'mis-dropdown-32'"></mis-dropdown> -->
<!-- {{JSON.stringify(selectOptions)}} {{this.type}} -->
 <!-- {{getCustomOptionLabel}} {{getCustomOptionValue}} -->
<div (click)="onClickSelectDropdown()" class="dropdownMain">
  <div (click)="onClickSelectDropdown()" class="dropdownMain"  [ngStyle]="showError()? {'border':'1px solid #B00020','border-radius':'6px'}:{}">
  <mis-dropdown [data]="selectOptions" [label]="selectOptions.length===0?'No data':label" [selectedItem]="selectedItem" ngDefaultControl [searchEnabled]="canSearch" (onChange)="onOptionClick($event)" [itemSizeForCdk]="itemSizeForCdk"
   [ngClass]="getStyle()" [class.mis-disabled]="(formControl && formControl.disabled) || selectOptions.length===0" *ngIf="!editableCostCenter"></mis-dropdown>
   <app-add-option-dropdown [data]="selectOptions" (onChange)="onOptionClick($event)" [selectedItem]="selectedItem" *ngIf="editableCostCenter"></app-add-option-dropdown>
</div>

<!-- <mat-form-field appearance="outline" [ngClass]="(((config?.displayName === 'Gender' || config?.displayName === 'City' || config?.displayName === 'Booking Type' || config?.displayName === 'Cab Type' || config?.displayName === 'Vendor') && (styleApplied !== 'editable-table' || selectStyleApplied === 'editable-table')) || (config?.displayName === 'Department' && selectStyleApplied !== 'editable-table') || (config?.displayName === 'Code' && selectStyleApplied !== 'editable-table')) ? 'select-form-field select-height-56' : 'select-form-field'">
  <mat-select class="custom-mat-select" [(ngModel)]="displayValue" (selectionChange)="onOptionClick($event.value)">
    <mat-option *ngFor="let option of selectOptions; let optionIndex = index" [value]="option">{{getOptionLabel(option)}}</mat-option>
  </mat-select>
</mat-form-field> -->
<div class="error" *ngIf="showError() && formControl.errors.required">
  <img src="assets/error-16.svg" alt="" class="error-icon">
  {{errorMessages.required}}</div>
<div class="error" *ngIf="showError() && (formControl.errors.pattern || formControl.errors.secure)">
  <img src="assets/error-16.svg" alt="" class="error-icon">
  {{config.errorMessage || errorMessages.pattern}}</div>
<!-- <div class="select-container" appClickOutside (clickOutside)="clickOutside()" [isActive]="isListShown">
  <div class="select-input-wrapper input-wrapper" (click)="handleTriggerClick($event)">
    <img *ngIf="value && hasIcon" [src]="getIconFromValue(this.value)" class="input-icon prefix"/>
    <input class="select-input input has-suffix"
      [readonly]="!canSearch && !canAdd"
      [disabled]="formControl && formControl.disabled"
      [placeholder]="placeholder"
      [(ngModel)]="displayValue"
      (blur)="handleInputBlur()"
      (click)="handleClickEvent()"
      (keyup)="handleInputChange($event)"
      (keypress)="preventEnterKeyBehaviour($event)"
      (keydown)="setHighlightedOption($event)"
      [ngClass]="{'input-error': showError(), 'has-prefix': value && hasIcon, 'has-clear': showClear}"
    />
    <img
      *ngIf="showClear && displayValue && (!formControl || !formControl.disabled)"
      (click)="clearInput($event)"
      src="assets/clear-circle-filled.svg"
      class="input-icon clear-icon"/>
    <img [src]="isListShown ? 'assets/caret-up.svg' : 'assets/caret-down.svg'" class="input-icon suffix"/>
  </div>
  <div class="select-list" *ngIf="isListShown" [ngClass]="{'width-200-imp': isNonCompliantVisible}">
    <div (click)="hideList()">
      <ng-content select="[additional-content]"></ng-content>
    </div>
    <ul class="options-list">
      <li class="select-option"
        *ngFor="let option of selectOptions; let optionIndex = index"
        (mouseup)="onOptionClick(option)"
        [ngClass]="{'active-item': optionIndex == activeOption, 'disableItem' : disableListElement && !isNonCompliantSelectable && !option.compliant}"
      > 
        <ng-container>
          <img *ngIf="hasIcon" [src]="option.icon" class="mr-10"/>
          <span>{{getOptionLabel(option)}}</span>
          <img *ngIf="isNonCompliantVisible && !option.compliant" src="assets/nonCompliance.svg" class="float-right"/>
          <img *ngIf="option.virtual" src="assets/Vcab_icn.svg" class="float-right"/>
        </ng-container>
      </li>
      <li class="no-results" *ngIf="selectOptions && !selectOptions.length">No options available</li>
    </ul>
  </div>
  <div class="error-msg" *ngIf="showError() && formControl.errors.required">{{errorMessages.required}}</div>
  <div class="error-msg" *ngIf="showError() && (formControl.errors.pattern || formControl.errors.secure)">{{config.errorMessage || errorMessages.pattern}}</div>
  </div> 
 -->